import { Availability, TimeOfDay } from "~/entities/baseEntities";
import {
  dayOfWeekByDayIndex,
  normaliseAvailability,
} from "~/helpers/siteHelpers";

export const isSameOrBefore = (a: TimeOfDay, b: TimeOfDay): boolean => {
  if (a.hour == b.hour) {
    return a.minute <= b.minute;
  } else {
    return a.hour <= b.hour;
  }
};
export const isBefore = (a: TimeOfDay, b: TimeOfDay): boolean => {
  if (a.hour == b.hour) {
    return a.minute < b.minute;
  } else {
    return a.hour < b.hour;
  }
};

export const getTimeOfDay = (localTime: Date): TimeOfDay => {
  return {
    hour: localTime.getHours(),
    minute: localTime.getMinutes(),
  };
};

export const isCurrentlyAvailable = (
  av: Availability[],
  localTime: Date
): boolean => {
  const normAv = normaliseAvailability(av);

  const dayOfWeek = dayOfWeekByDayIndex[localTime.getDay()];
  const timeOfDay = getTimeOfDay(localTime);

  return normAv.some(
    (x) =>
      x.applies[dayOfWeek] &&
      isSameOrBefore(x.startsAt, timeOfDay) &&
      isBefore(timeOfDay, x.endsAt)
  );
};
